import { RpcRequest } from '@message-bus/core';
import { NativeNamespaces } from '@mobile-data-access-enums';
import { WebViewNativeMethods } from '@mobile-data-access-enums';

@RpcRequest(NativeNamespaces.EMBEDDED_WEB_VIEW, WebViewNativeMethods.CLOSE)
export class CloseWebviewNativeMethod {}
